import { SERVICEURI } from "../const/serviceuri";
import { getRequest } from "../Instance/fetchRequest";

const verifySignin = ({ email, password }) => {
  let endPoint = SERVICEURI.Signin
    .replace("{email}", email)
    .replace("{password}", password);
  return new Promise(async (onSuccess, onFailure) => {
    await getRequest(endPoint)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onFailure(error);
      });
  });
};
const signInService = {
  verifySignin,
}

export default signInService;